<template>
    <div class="home">
        <div class="hero-banner">
            <div class="container text-center pt-0">
                <h1 class="white--text" v-html="page.schoolSearchTitle"></h1>
                <h2 class="white--text">{{page.schoolSearchSubTitle}}</h2>

                <v-row>
                    <v-col class="justify-center d-flex">
                        <SchoolCityAutoComplete></SchoolCityAutoComplete>
                    </v-col>
                </v-row>
            </div>
        </div>

        <ContinuousCarousel :pageName="pageName" />
        <div class="about">
            <div class="content">
                <div class="row">
                    <div class="content-col">
                        <img src="../../src/assets/media/edu_rent_verified_logo.png" alt="Verified Logo">
                        <p v-html="page.blockAboutText"></p>
                        <div class="list-items" v-html="page.blockAboutLists">
                        </div>
                    </div>
                    <div class="content-img-col" v-if="page.blockAboutImage">
                        <img :src="getPathFromMedia + page.blockAboutImage.url" alt="Edurent About Photo"
                            title="Edurent About Photo">
                    </div>
                </div>
            </div>
        </div>

        <div class="best-apartments row-reverse bg-v-3">
            <div class="content">
                <div class="row py-2">
                    <div class="col-12 col-md-6 col-lg-5 px-0">
                        <h2>{{ page.filledBlockContentTitle }}</h2>
                        <div class="mt-3" v-html="page.filledBlockContentText">
                        </div>
                        <v-btn @click="openSignUp" depressed color="primary">Create Account</v-btn>
                    </div>
                    <div class="d-none d-lg-block col-lg-6"></div>
                </div>
            </div>
        </div>

        <div class="comprasion">
            <div class="content">
                <div class="row">
                    <div class="left-col">
                        <div class="comprasion-content">
                            <img src="../../src/assets/media/edu_rent_verified_logo.png" alt="Verified Logo">
                            <div v-html="page.comprasionContentLeft">
                            </div>
                        </div>
                    </div>
                    <div class="right-col">
                        <div class="comprasion-content">
                            <h3>{{ page.comprasionContentRightTitle }}</h3>
                            <div v-html="page.comprasionContentRight"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="simple-steps mb-12 pb-4 pb-md-11">
            <div class="content">
                <div class="row mb-2">
                    <h2>{{page.callToActionMainTitle}}</h2>
                    <SimpleSteps :callToActions="page.call_to_actions" v-if="page.call_to_actions"></SimpleSteps>
                     <v-btn class="ma-2 btn-edurent px-10 mt-4" outlined color="primary" @click="openSignUp" height="45"
                        width="170px">
                        Create Account
                    </v-btn>

                </div>
            </div>
        </div>
        <div class="best-apartments bg-v-1">
            <div class="content">
                <div class="row py-2">
                    <div class="col-12 col-md-6 px-0 pr-md-10 px-lg-0 px-lg-2">
                        <h2>{{ page.blockSelectApartmentsTitle }}</h2>
                        <div class="mt-8" v-html="page.blockSelectApartmentsContent">
                        </div>
                    </div>
                    <div class="col-12 col-md-6 dashboard-col px-0 px-lg-12">
                        <div class="dashboard" v-html="page.blockSelectApartmentsList">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content major-cities-content mt-6 mt-lg-10 mb-lg-3 py-1">

        <!--- MAJOR CITIES --->
        <div id="major-cities" class="major-cities px-lg-3 py-lg-0">
            <div class="major-cities-container">
                <div class="first-card">
                    <v-hover v-slot:default="{hover}">
                        <v-card class="mr-sm-2" :elevation="hover ? 16 : 2"
                            :to="`search-properties/city/${cities[0].url}`">
                            <v-img :src="cities[0].image"></v-img>
                            <div class="major-cities-card-content">
                                <span
                                    :class="$vuetify.breakpoint.smAndDown ? 'major-cities-title-mobile' : 'major-cities-title'">
                                    {{cities[0].city}}
                                </span>
                                <span class="major-cities-subtitle">
                                    {{cities[0].text}}
                                </span>
                            </div>
                        </v-card>
                    </v-hover>
                </div>
                <div class="second-card">
                    <v-hover v-slot:default="{hover}">
                        <v-card class="ml-2" :elevation="hover ? 16 : 2"
                            :to="`search-properties/city/${cities[1].url}`">
                            <v-img :src="cities[1].image"></v-img>
                            <div class="major-cities-card-content">
                                <span
                                    :class="$vuetify.breakpoint.smAndDown ? 'major-cities-title-mobile' : 'major-cities-title'">
                                    {{cities[1].city}}
                                </span>
                                <span class="major-cities-subtitle">
                                    {{cities[1].text}}
                                </span>
                            </div>
                        </v-card>
                    </v-hover>
                </div>
                <div class="third-card">
                    <v-hover v-slot:default="{hover}">
                        <v-card class="ml-2" :elevation="hover ? 16 : 2"
                            :to="`search-properties/city/${cities[2].url}`">
                            <v-img :src="cities[2].image"></v-img>
                            <div class="major-cities-card-content">
                                <span
                                    :class="$vuetify.breakpoint.smAndDown ? 'major-cities-title-mobile' : 'major-cities-title'">
                                    {{cities[2].city}}
                                </span>
                                <span class="major-cities-subtitle">
                                    {{cities[2].text}}
                                </span>
                            </div>
                        </v-card>
                    </v-hover>
                </div>
                <div class="forth-card">
                    <v-hover v-slot:default="{hover}">
                        <v-card class="mr-sm-2" :elevation="hover ? 16 : 2"
                            :to="`search-properties/city/${cities[3].url}`">
                            <v-img :src="cities[3].image"></v-img>
                            <div class="major-cities-card-content">
                                <span
                                    :class="$vuetify.breakpoint.smAndDown ? 'major-cities-title-mobile' : 'major-cities-title'">
                                    {{cities[3].city}}
                                </span>
                                <span class="major-cities-subtitle">
                                    {{cities[3].text}}
                                </span>
                            </div>
                        </v-card>
                    </v-hover>
                </div>
                <div class="five-card">
                    <v-hover v-slot:default="{hover}">
                        <v-card class="ml-2" :elevation="hover ? 16 : 2"
                            :to="`search-properties/city/${cities[4].url}`">
                            <v-img :src="cities[4].image"></v-img>
                            <div class="major-cities-card-content">
                                <span
                                    :class="$vuetify.breakpoint.smAndDown ? 'major-cities-title-mobile' : 'major-cities-title'">
                                    {{cities[4].city}}
                                </span>
                                <span class="major-cities-subtitle">
                                    {{cities[4].text}}
                                </span>
                            </div>
                        </v-card>
                    </v-hover>
                </div>
            </div>
        </div>
    </div>

        <!--- CAROUSEL GOES HERE --->
        <v-row>
            <v-col colms="12" class="text-center home-testimonials-title mb-5">
                <h2>Here’s What People Are Saying About EDUrent</h2>
            </v-col>
        </v-row>
        <TestimonialsCarousel :testimonialsData="page.testimonials" v-if="page.testimonials"></TestimonialsCarousel>
        <div class="best-apartments row-reverse bg-v-2">
            <div class="content">
                <div class="row pb-3">
                    <div class="col-12 col-md-6 pt-6 px-0">
                        <h2 class="mb-6">{{ page.rentPlaceBlockTitle }}</h2>
                        <div class="mt-2" v-html="page.rentPlaceBlockContent">
                        </div>
                        <v-btn @click="openSignUp" depressed color="primary">Create Account</v-btn>
                    </div>
                    <div class="d-none d-lg-block col-lg-6"></div>
                </div>
            </div>
        </div>
        <div class="block-news">
            <div class="content">
                <div class="row">
                    <div class="block-news__card-wrap" v-for="(item, index) in page.learn_mores" :key="index">
                        <router-link  :to="item.link">
                            <div class="block-news__card" @click="getClickBtn(item.title)">
                                <div class="block-news__card-image"
                                    :style="{ backgroundImage: `url(` + getPathFromMedia + item.image.url + `)` }">
                                </div>
                                <div class="block-news__card-band">{{item.title}}</div>
                                <div class="block-news__card-text">
                                    {{item.content}}
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>

        <div class="apartments-list apartments-list-desktop" v-if="page.footer && page.footer.cityApartments">
            <v-spacer></v-spacer>
            <div class="px-6" v-for="(item, i) in page.footer.cityApartments" :key="i">
                <h4>{{item.title}}</h4>
                <ul>
                    <li v-for="(apartment, i) in item.apartments" :key="i">{{apartment.title}}</li>
                </ul>
            </div>
            <v-spacer></v-spacer>
        </div>

        <div class="apartments-list apartments-list-mobile" v-if="page.footer && page.footer.cityApartments">
            <v-expansion-panels tile flat>
                <v-expansion-panel v-for="(item, i) in page.footer.cityApartments" :key="i" class="pa-0">
                    <v-expansion-panel-header>
                        <div class="py-4">
                            {{item.title}}
                        </div>
                        <template v-slot:actions>
                            <v-icon color="white">
                                mdi-chevron-down
                            </v-icon>
                        </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="pb-6">
                            <ul>
                                <li v-for="(apartment, i) in item.apartments" :key="i">{{apartment.title}}
                                </li>
                            </ul>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>

    </div>
</template>

<script>
import SiteService from "../services/site.service";
import BusinessService from "../services/business.service";
import SchoolCityAutoComplete from "@/components/SchoolCityAutoComplete";
import ContinuousCarousel from "../components/ContinuousCarousel.vue";
import SimpleSteps from "../components/SimpleSteps.vue";
import TestimonialsCarousel from "../components/TestimonialsCarousel.vue";
import {flattenObj} from "@/utils/utils";

export default {
    name: 'Home',

    components: {
        SchoolCityAutoComplete,
        ContinuousCarousel,
        SimpleSteps,
        TestimonialsCarousel
    },

    metaInfo() {
        return {
            title: this.metaTitle,
            meta: [
                { name: 'description', content: this.metaDescription },
                {
                    keyName: this.keywords
                }
            ]
        }
    },

    data() {
        return {
            metaTitle: '',
            metaDescription: 'EDUrent\'s shared housing program provides the traditional college experience. Students share a space with classmates and make new friends on day one at move-in. Instead of a cramped, overpriced dorm room, you have the space and luxury of a full-size apartment home with a well-equipped kitchen. Our units are furnished with beds, dressers, and a couch and include utilities like electricity, and water, all at one low monthly cost. Each student in the program has an individual lease agreement and therefore is not responsible for roommates\' rent payments should a bed become vacant. Students in this program tend to carpool to school, study together, and share in this new life experience. Welcome to EDUrent!',
            keywords: '',
            pageName: 'Home',
            userInput: '',
            colors: [
                'grey lighten-2',
                'warning',
                'pink darken-2',
                'red lighten-1',
                'deep-purple accent-4',
            ],
            page: [],
            isLoadingResults: false,
            searchResults: [],
            search: null,
            propertyStats: [],
            cityImages: {},
            getPathFromMedia: process.env.VUE_APP_CMS_BASE_URL ?? 'https://cms.edurent.com'
        };
    },

    computed: {
        cities() {
            let propertes = JSON.stringify(this.propertyStats);
            let property_0 = JSON.parse(propertes)[0] ?? '';
            let property_1 = JSON.parse(propertes)[1] ?? '';
            let property_2 = JSON.parse(propertes)[2] ?? '';
            let property_3 = JSON.parse(propertes)[3] ?? '';
            let property_4 = JSON.parse(propertes)[4] ?? '';

            return [
                {
                city: propertes && property_0 && property_0.city ? property_0.city : 'Orlando, Florida',
                    url: propertes && property_0 && property_0.state_id
                        ? `${property_0.city}/${property_0.state_id}`
                    : 'Orlando/9',
                    text: propertes && property_0 && property_0.count
                        ? this.pluralText(property_0.count)
                    : '25 Apartments',
                    image: propertes && property_0 && property_0.state_id && this.getCityImage(property_0.city) !== false
                        ? this.getCityImage(property_0.city)
                    : this.getPathFromMedia + "/uploads/Image_c9e37f94e4.jpg?updated_at=2022-08-25T01:21:32.894Z"
                },
                {
                    city: propertes && property_1 && property_1.city ? property_1.city : 'Jacksonville, Florida',
                    url: propertes && property_1 && property_1.state_id
                        ? `${property_1.city}/${property_1.state_id}`
                    : 'Jacksonville/9',
                    text: propertes && property_1 && property_1.count
                        ? this.pluralText(property_1.count)
                    : '15 Apartments',
                    image: propertes && property_1 && property_1.state_id && this.getCityImage(property_1.city) !== false
                        ? this.getCityImage(property_1.city)
                    : this.getPathFromMedia + "/uploads/Image_1_e6d9e99e0d.jpg?updated_at=2022-08-25T01:37:48.291Z"
                },
                {
                    city: propertes && property_2 && property_2.city ? property_2.city : 'TULSA, Oklahoma',
                    url: propertes && property_2 && property_2.state_id
                        ? `${property_2.city}/${property_2.state_id}`
                    : 'Tulsa/36',
                    text: propertes && property_2 && property_2.count
                        ? this.pluralText(property_2.count)
                    : '12 Apartments',
                    image: propertes && property_2 && property_2.state_id && this.getCityImage(property_2.city) !== false
                        ? this.getCityImage(property_2.city)
                    : this.getPathFromMedia + "/uploads/Image_3_2869f80c7e.jpg?updated_at=2022-08-25T01:39:38.292Z"
                },
                {
                    city: propertes && property_3 && property_3.city ? property_3.city : 'Houston, Texas',
                    url: propertes && property_3 && property_3.state_id
                        ? `${property_3.city}/${property_3.state_id}`
                    : 'Houston/43',
                    text: propertes && property_3 && property_3.count
                        ? this.pluralText(property_3.count)
                    : '30 Apartments',
                    image: propertes && property_3 && property_3.state_id && this.getCityImage(property_3.city) !== false
                        ? this.getCityImage(property_3.city)
                    : this.getPathFromMedia + "/uploads/Image_1_b83a367e0c.jpg?updated_at=2022-08-25T01:21:32.856Z"
                },
                {
                    city: propertes && property_4 && property_4.city ? property_4.city : 'Louisville, Kentucky',
                    url: propertes && property_3 && property_4.state_id
                        ? `${property_4.city}/${property_4.state_id}`
                    : 'Louisville/17',
                    text: propertes && property_4 && property_4.count
                        ? this.pluralText(property_4.count)
                    : '8 Apartments',
                    image: propertes && property_4 && property_4.state_id && this.getCityImage(property_4.city) !== false
                        ? this.getCityImage(property_4.city)
                    : this.getPathFromMedia + "/uploads/Image_2_3a7592f186.jpg?updated_at=2022-08-25T01:21:32.909Z"
                }
            ]
        },
    },

    watch: {
        search(val) {
            val && val !== this.userInput && this.debouncedSearch(val)
        }
    },

    async beforeMount() {
        const response = await SiteService.getHomePage();
        this.page = flattenObj(response);

        this.cityImages = await this.fetchCityImages();
        this.propertyStats = await this.fetchPropertyStats();

        this.metaTitle = this.page.metaTitle;
        this.metaDescription = this.page.metaDescription;
        this.keywords = this.page.keywords;
    },

    methods: {
        getClickBtn (btnTitle) {
            const options = {
                method: 'POST',
                headers: { accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    data: '{"token": "TAEE6J", "event": "Clicked button - ' + btnTitle + '", "customer_properties": {"$email": "edurent@klaviyo.com"}}'
                })
            };

            fetch('https://a.klaviyo.com/api/track', options)
                .then(response => response.json());
        },

        openSignUp() {
            const options = {
                method: 'POST',
                headers: { accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    data: '{"token": "TAEE6J", "event": "Clicked button - Create Account", "customer_properties": {"$email": "edurent@klaviyo.com"}}'
                })
            };

            fetch('https://a.klaviyo.com/api/track', options)
                .then(response => response.json());

            this.$store.dispatch('setSignUpModal', true)
        },

        getIconUrl(url = '') {
            return this.getPathFromMedia + url;
        },

        pluralText(length) {
            if (length <= 0) return 'No properties'

            return length > 1 ? `${length} Properties` : `${length} Property`;
        },

        getCityImage(city) {
            const cityName = city.toLowerCase();

            if (this.cityImages[cityName]) {
                return this.getPathFromMedia + this.cityImages[cityName];
            }

            return null;
        },

        async fetchCityImages() {
            const images = (await SiteService.getCityImages())?.[0]?.attributes?.['Images']?.data || [];
            return images
                .map((image) => ({
                    name: image?.attributes?.name?.toLowerCase() || '',
                    url: image?.attributes?.formats?.medium?.url || '',
                }))
                .filter((image) => image.name !== '' && image.url !== '')
                .reduce((accumulator, image) => {
                    accumulator[image.name] = image.url;
                    return accumulator;
                }, {});
        },

        async fetchPropertyStats() {
            const stats = await BusinessService.getPropertyCounts();
            if (! stats?.topMarkets && ! stats?.randomizedMarkets) {
                return [];
            }

            const marketStats = [];

            const filterMarkets = (market) => {
                return market.city
                    && market.state_id >= 0
                    && market.count > 0
                    && this.getCityImage(market.city);
            };

            const mapMarkets = (market) => {
                return {
                    name: market.city,
                    count: market.count,
                    url: `${market.city}/${market.state_id}`,
                    text: this.pluralText(market.count),
                    image: this.getCityImage(market.city),
                };
            };

            const sortMarkets = (a, b) => b.count - a.count;

            // Get each randomized market first
            if (stats.randomizedMarkets && stats.randomizedMarkets.length > 0) {
                const markets = stats.randomizedMarkets
                    .sort(sortMarkets)
                    .filter(filterMarkets)
                    .slice(0, 6)
                    .map(mapMarkets);

                // Push the markets to the marketsStats list
                marketStats.push(...markets);
            }

            // Next get any remaining top markets
            let remainingMarkets = 5 - marketStats.length;
            if (remainingMarkets > 0 && stats.topMarkets && stats.topMarkets.length > 0) {
                const markets = stats.topMarkets
                    .sort(sortMarkets)
                    .filter(filterMarkets)
                    .slice(0, remainingMarkets)
                    .map(mapMarkets);

                // Push the markets to the marketsStats list
                marketStats.push(...markets);
            }

            // Return the market stats list
            return marketStats.sort(sortMarkets);
        },
    },
};
</script>

<style scoped>
.home {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
}

.block-testimonials__container {
    padding-bottom: 4%;
    background: -webkit-gradient(linear, left top, left bottom, from(rgba(239, 243, 254, 0)), to(#F0F3FE));
    background: -o-linear-gradient(top, rgba(239, 243, 254, 0) 0%, #F0F3FE 100%);
    background: linear-gradient(180deg, rgba(239, 243, 254, 0) 0%, #F0F3FE 100%);
}

>>>.content>.row {
    width: 100%;
    margin: 0;
}

.block-news {
    z-index: 5;
}

>>>.about .content {
    padding: 7.4% 0 6.4%;
}

.comprasion .content,
>>>.about .content,
.simple-steps .content,
.home-testimonials,
.hero-banner .container,
.content.major-cities-content,
.block-news div.content,
.best-apartments div.content {
    width: 90%;
    max-width: 1505px;
    padding-left: 20px;
    padding-right: 20px;
}

.content.major-cities-content a.v-card--link:hover {
    -webkit-box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 5%), 0px 16px 24px 2px rgb(0 0 0 / 4%), 0px 6px 30px 5px rgb(0 0 0 / 2%) !important;
    box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 5%), 0px 16px 24px 2px rgb(0 0 0 / 4%), 0px 6px 30px 5px rgb(0 0 0 / 2%) !important;
}

footer.secondary {
    background-color: #000000 !important;
}

.autocomplete-home .v-input__control {
    border-radius: 5px;
}

div.hero-banner {
    padding-top: 140px;
    margin-top: -66px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    min-height: 630px;
    background-image: url("../../src/assets/media/hero-desktop.jpg");
    background-position: center center;
    background-size: cover;
    width: 100vw;
    height: auto;
    position: relative;
    z-index: 1;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

div.hero-banner:before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .5);
    z-index: 1;
}

.sponsors-section {
    background-color: black;
    padding: 28px 0;
}

.sponsors-section .owl-item {
    opacity: 0.6;
}

#major-cities div {
    border: 0px solid grey;
}

#major-cities.major-cities {
    max-height: 90vh;
    overflow: hidden;
}

#major-cities .col-12 {
    max-height: 100%;
}

#major-cities img {
    max-width: 100%;
}

#major-cities.major-cities {
    max-height: none;
    overflow: hidden;
}

.major-cities .major-cities-title-mobile,
.major-cities .major-cities-title {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.3;
    /* identical to box height, or 169% */

    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin-top: -5px;

    /* Black */

    color: #000000;
}

.major-cities .major-cities-subtitle {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    /* identical to box height, or 162% */


    color: #5D6E7F;
}

@media (max-width: 1024px) {
    .major-cities .major-cities-subtitle {
        display: none;
    }

    >>>.home-testimonials__container .v-window__container {
        max-height: 377px;
    }

    .home-testimonials__container {
        height: 510px;
    }
}

.major-cities .v-card {
    border-radius: 15px !important;
}

.major-cities {
    width: 100%;
    margin-top: 50px;
    margin-bottom: 70px;
}

.major-cities-container {
    width: 100%;
    height: 955px;
    position: relative;
    padding: 10px 0;
}

.major-cities-container>div:hover {}

.major-cities .first-card {
    width: 50%;
    position: absolute;
    top: 10px;
    left: 0;
}

.major-cities .first-card .v-card {
    height: 578px;
}

.major-cities .first-card .v-card .v-image {
    height: 490px;
}

.major-cities .second-card .v-card .v-image,
.major-cities .third-card .v-card .v-image,
.major-cities .forth-card .v-card .v-image {
    height: 250px;
}

.major-cities .second-card,
.major-cities .third-card {
    height: 333px;
    width: 25%;
    position: absolute;
    top: 10px;
    right: 25%;
}

.major-cities .second-card .v-card,
.major-cities .third-card .v-card,
.major-cities .forth-card .v-card {
    height: 333px;
}

.major-cities .third-card {
    right: 0;
}

.major-cities .first-card .v-card .v-image {
    height: 490px;
}

.major-cities .first-card .v-card {
    height: 578px;
}

.major-cities .forth-card {
    height: 333px;
    width: 50%;
    position: absolute;
    bottom: 35px;
    left: 0;
}

.major-cities .five-card {
    height: 578px;
    width: 50%;
    position: absolute;
    bottom: 35px;
    right: 0;
}

.major-cities .five-card .v-card {
    height: 100%;
}

>>>.major-cities .five-card .v-card .v-responsive__sizer {
    height: 495px;
}

.major-cities-card-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    height: 93px;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0 20px;
}

.apartments-list {
    background: #33363F;
    color: #FFF;
    padding: 40px 0;
}

.apartments-list h4 {
    list-style: none;
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 21px;
    margin-bottom: 5px;
}

.apartments-list li {
    list-style: none;
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 23px;
}

.apartments-list ul {
    list-style: none;
    padding: 0 !important;
}

.apartments-list-desktop {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}

.apartments-list-mobile {
    display: none !important;
}

.apartments-list-mobile .v-expansion-panels .v-expansion-panel {
    background: transparent !important;
    border-bottom: 1px solid #D8D8D8;
    color: #FFF !important;
}

.apartments-list-mobile .v-expansion-panels {
    max-width: 500px;
}

@media (max-width: 1024px) {

    .apartments-list {
        padding: 40px 30px;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }

    .apartments-list-desktop {
        display: none !important;
    }

    .apartments-list-mobile {
        display: -webkit-box !important;
        display: -ms-flexbox !important;
        display: flex !important;
    }
}

.hero-banner h1 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 64px;
    line-height: 72px;
    max-width: 1300px;
    margin: auto;
    margin-top: 4.3%;
}

.hero-banner h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    margin-top: 1rem;
    margin-bottom: 2rem;
}

@media (max-width: 1024px) {
    .hero-banner h1 {
        padding-left: 15%;
        padding-right: 15%;
        font-size: 30px;
    }
}

@media (max-width: 1024px) {
    .hero-banner h2 {
        font-size: 16px;
    }

    .major-cities-container {
        margin-left: -8px;
        margin-right: -8px;
    }

    .major-cities-container {
        height: 670px;
        margin: auto;
    }

    .major-cities .first-card .v-card {
        height: 384px;
    }

    .major-cities .first-card .v-card .v-image {
        height: 320px;
    }

    .major-cities .five-card {
        height: 383px;
        bottom: 25px;
    }

    >>>.major-cities .first-card .v-card .v-image v-responsive theme--light {
        height: 325px;
    }

    .major-cities-card-content {
        height: 62px;
    }

    >>>.major-cities .five-card .v-card .v-responsive__content {
        height: 325px;
    }

    >>>.major-cities .five-card .v-card .v-responsive__sizer {
        height: 150px;
    }

    .major-cities .second-card .v-card,
    .major-cities .third-card .v-card,
    .major-cities .forth-card .v-card,
    .major-cities .second-card,
    .major-cities .third-card {
        height: 230px;
    }

    .major-cities .second-card .v-card .v-image,
    .major-cities .third-card .v-card .v-image,
    .major-cities .forth-card .v-card .v-image {
        height: 170px;
    }

    .major-cities .forth-card {
        height: 245px;
    }
}

.home-testimonials .v-btn:before {
    display: none;
}

.major-cities h2,
.partner-with-us h2 {
    font-size: 30px !important;
}

@media (max-width: 1024px) {

    .major-cities h2,
    .partner-with-us h2 {
        font-size: 26px !important;
        line-height: 36px !important;
    }
}

.partner-with-us .v-card {
    border-radius: 10px !important;
    padding: 50px;
}

@media (max-width: 1024px) {
    .partner-with-us .v-card {
        padding: 30px;
    }

    .partner-with-us .v-card:first-child {
        margin-bottom: 15px;
    }
}

.partner-with-us .v-card .v-card__text p:first-child {
    font-weight: 700;
    font-size: 26px !important;
}

.partner-with-us .v-card .v-card__text p:last-child {
    font-size: 16px;
    font-weight: 400;
    color: white;
}

.partners-cards {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
}

@media (max-width: 1024px) {
    .partners-cards {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .block-news .col-12 {
        margin: 0;
        padding: 0;
    }
}

.home-highlight h1 {
    font-size: 30px;
    line-height: 45px;
    font-weight: 700;
}

@media (max-width: 1024px) {
    .home-highlight h1 {
        font-size: 26px;
        line-height: 36px;
    }

    .hero-banner h1 {
        font-size: clamp(30px, 3em, 50px);
        padding-left: 0;
        padding-right: 0;
    }
}

.home-highlight h3 {
    font-size: 20px;
    line-height: 30px;
    font-weight: 700;
    margin-bottom: 8px;
    margin-top: 20px;
}

.home-highlight p {
    font-size: 16px;
    font-weight: 400;
}

.best-apartments {
    background-repeat: no-repeat !important;
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: 4.5% 0;
}

.best-apartments.row-reverse .row {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    -ms-flex-direction: row-reverse;
    flex-direction: row-reverse;
}

.best-apartments.bg-v-1 {
    background-size: 100% 100% !important;
    background-position: center right !important;
    background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0.5))), url(../../src/assets/media/background-new.jpg);
    background: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(../../src/assets/media/background-new.jpg);
    background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(../../src/assets/media/background-new.jpg);
}

.best-apartments.bg-v-2 {
    background-size: 54% 100% !important;
    background-position: center left !important;
    background: url(../../src/assets/media/bg-new-2.jpg), #373E55;
}

.best-apartments.bg-v-3 {
    background-size: 55% 100% !important;
    background-position: center left !important;
    background: url(../../src/assets/media/bg-v-3.jpg), #373E55;
}

.best-apartments.bg-v-1:before {
    position: absolute;
    content: '';
    top: 0;
    left: 0;
    width: 70%;
    height: 100%;
    -webkit-transform: rotate(-180deg);
    -ms-transform: rotate(-180deg);
    transform: rotate(-180deg);
    background: -o-linear-gradient(180.13deg, #373E55 57.17%, rgba(55, 62, 85, 0) 108.01%);
    background: linear-gradient(269.87deg, #373E55 57.17%, rgba(55, 62, 85, 0) 108.01%);
}

.best-apartments.bg-v-2:before,
.best-apartments.bg-v-3:before {
    position: absolute;
    content: '';
    top: 0;
    right: 44%;
    width: 35%;
    height: 100%;
    background: -webkit-gradient(linear, right top, left top, from(#373E55), to(rgba(55, 62, 85, 0)));
    background: -o-linear-gradient(right, #373E55 0%, rgba(55, 62, 85, 0) 100%);
    background: linear-gradient(270deg, #373E55 0%, rgba(55, 62, 85, 0) 100%);
}

.best-apartments .content {
    z-index: 3;
}

.best-apartments .row {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
}

.best-apartments .row .col-12:first-child {
    max-width: 660px;
}

.best-apartments.bg-v-2 .row .col-12:first-child {
    max-width: 630px;
}

.best-apartments h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 40px;
    max-width: 615px;


    /* White */

    color: #FFFFFF;
}

>>>.best-apartments p {
    color: #FFFFFF;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    padding-bottom: 2rem;
}

>>>.best-apartments p:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
}

>>>.best-apartments .dashboard {
    background: #2D76E3;
    /* Drop Shadow 2 */

    -webkit-box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);

    box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    padding: 8% 7% 6% 49px;
    max-width: 570px;
}

>>>.best-apartments .dashboard ul li {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 1.9;
    /* identical to box height, or 169% */
    position: relative;
    text-transform: capitalize;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;

    /* White */

    color: #FFFFFF;
    padding-bottom: .4rem;
}

>>>.best-apartments .dashboard ul li:last-child {
    padding-bottom: 0;
}

.block-news {
    margin: 5.5% 0;
}

.block-news__card:hover {
    -webkit-box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%);
    box-shadow: 0px 8px 10px -5px rgb(0 0 0 / 20%), 0px 16px 24px 2px rgb(0 0 0 / 14%), 0px 6px 30px 5px rgb(0 0 0 / 12%);
}

.block-news__card-band {
    height: 56px;
    background: #2D76E3;
    color: #fff;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 40px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.block-news__card-text {
    padding: 5%;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    /* or 162% */


    /* Black */

    color: #000000;
}

.block-news__card {
    padding: 0px;
    max-width: 97;
    background: #FFFFFF;
    -webkit-box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
}

.block-news .col-12:last-child .block-news__card {
    margin-left: auto;
}

.best-apartments .dashboard-col {
    padding: 3% 4%;
}

>>>.best-apartments .dashboard ul {
    padding-left: 0;
    list-style: none;
}

.list-item__icon {
    padding-right: 20px;
    padding-top: 5px
}

.block-news__card-image {
    height: 324px;
    background-size: cover;
}

.block-news__card {
    overflow: hidden;
    height: 100%;
}

.best-apartments .v-btn:not(.v-btn--round).v-size--default {
    margin-top: 1.8rem;
    width: 161px;
    height: 45px;
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: normal;
    text-transform: capitalize;
}

@media (max-width: 959px) {
    >>>.best-apartments .dashboard-col {
        padding: 12px;
        margin-top: 1rem;
    }

    .block-news {
        margin-bottom: 100px;
        margin-top: 100px;
    }

    .block-news {
        margin-left: auto;
        margin-right: auto;
    }

    .block-news .col-12:last-child .block-news__card {
        margin-left: auto;
    }
}

@media (max-width: 575px) {
    .best-apartments div.content {
        width: 100%;
        padding: 0 12px;
    }

    .block-news .col-12 {
        padding-left: 0;
        padding-right: 0;
    }

    .block-news .col-12 {
        margin-bottom: 2rem;
    }

    .block-news__card {
        margin: auto;
    }

    .best-apartments {
        padding: 50px 0;
    }

    >>>.best-apartments .dashboard {
        padding: 35px;
    }

    >>>.best-apartments h2 {
        font-size: 24px;
        line-height: 1.5;
    }

    .block-news__card-text {
        padding: 7% 5%;
    }
}

/* Edurent About Section Styles */

>>>.about .content .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
    margin: 0;
}

>>>.about .content .content-col {
    -webkit-box-flex: 0;
    -ms-flex: 0 1 44.1%;
    flex: 0 1 44.1%;
    padding: 3.65% 0;
    text-align: center;
}

>>>.about .content .content-col p {
    max-width: 630px;
    margin: 0 auto;
    margin-top: 43px;
    line-height: 1.60;
}

>>>.about .content .content-col .list-items {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    max-width: 633px;

}

>>>.about .content .content-col ul {
    display: inline-block;
    margin-top: 44px;
    list-style: none;
    text-align: left;
    padding-left: 0;
    clear: both;
}
>>>.about .content .content-col ul:first-child {
    width: 47%;
}
>>>.about .content .content-col ul:last-child {
    width: 51%;
}
>>>.dashboard ul li,
>>>.about .content .content-col ul li {
    position: relative;
    margin-bottom: 14px;
    padding-left: 35px;
}

>>>.dashboard ul li:before {
    content: "";
    position: absolute;
    width: 14px;
    height: 35px;

    left: 9px;
    top: 8px;

    background-image: url('../../src/assets/icons/check-circle.svg');
    background-size: contain;
    background-repeat: no-repeat;
}

>>>.about .content .content-col ul li::before {
    content: "";
    position: absolute;
    width: 14px;
    height: 35px;

    left: 9px;
    top: 8px;

    background-image: url('../../src/assets/icons/green_check.png');
    background-size: contain;
    background-repeat: no-repeat;
}

>>>.about .content .content-img-col {
    -webkit-box-flex: 0;
    -ms-flex: 0 1 49%;
    flex: 0 1 49%;
    padding-right: 10px;
}

>>>.about .content .content-img-col img {
    width: 100%;
    -webkit-box-shadow: 0px 6.09892px 6.09892px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 6.09892px 6.09892px rgba(0, 0, 0, 0.25);
    border-radius: 15.2473px;
}

@media (max-width: 1300px) {
    >>>.about .content .content-col .list-items {
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    >>>.about .content .content-col ul:first-child {
        width: 100%;
    }
}
@media (max-width: 980px) {
    >>>.about .content .row {
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
    }
    >>>.about .content .content-col ul:first-child {
        width: 47%;
    }

    >>>.about .content .content-col,
    >>>.about .content .content-img-col {
        -webkit-box-flex: 0;
        -ms-flex: 0 1 100%;
        flex: 0 1 100%;
        padding: 0;
    }

    >>>.about .content .content-col .list-items {
        max-width: 700px;
        margin: 0 auto;
        margin-bottom: 34px;
    }

    >>>.home-testimonials__container .v-window__container {
        max-height: 410px;
    }
}

@media (max-width: 768px) {
    >>>.about .content .content-col ul {
        width: 100% !important;
    }

    >>>.about .content .content-col ul:last-child {
        margin-top: 0;
    }
}

.comprasion {
    background: -webkit-gradient(linear, left top, left bottom, from(#F0F3FE), to(rgba(239, 243, 254, 0)));
    background: -o-linear-gradient(top, #F0F3FE 0%, rgba(239, 243, 254, 0) 100%);
    background: linear-gradient(180deg, #F0F3FE 0%, rgba(239, 243, 254, 0) 100%);
}

.comprasion .content {
    max-width: 1385px;
    width: 93%;
    padding: 7.4% 0;
    padding-bottom: 5.5%;
}

.comprasion .content .row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.comprasion .left-col {
    -webkit-box-flex: 0;
    -ms-flex: 0 1 45.5%;
    flex: 0 1 45.5%;

}

>>>.left-col .comprasion-content {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    background: #FFFFFF;
    -webkit-box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    padding: 13% 11.6% 18% 11.6%;
}

>>>.left-col .comprasion-content img {
    margin: 0 35px;
    max-width: 100%;
}

>>>.left-col .comprasion-content ul {
    margin-top: 12%;
    list-style: none;
}

>>>.left-col .comprasion-content li {
    position: relative;
    margin-bottom: 6.6%;
    line-height: 1.6;
    color: #000;
}

>>>.left-col .comprasion-content li b {
    color: #2D76E3;
    text-transform: uppercase;
}

>>>.left-col .comprasion-content li::before {
    content: "";
    position: absolute;
    width: 14px;
    height: 35px;

    left: -23px;
    top: 8px;

    background-image: url('../../src/assets/icons/green_check.png');
    background-size: contain;
    background-repeat: no-repeat;
}

>>>.comprasion .right-col {
    -webkit-box-flex: 0;
    -ms-flex: 0 1 45%;
    flex: 0 1 45%;
}

>>>.right-col .comprasion-content {
    padding: 10.4% 5%;
}

>>>.right-col .comprasion-content h3 {
    max-width: 450px;
    margin: 0 auto;
    font-weight: 700;
    font-size: 26px;
    text-align: center;
    color: #000;
}

>>>.right-col .comprasion-content ul {
    max-width: 525px;
    padding-left: 10.5%;
    padding-top: 10%;
    list-style: none;
}

>>>.right-col .comprasion-content li {
    position: relative;
    margin-bottom: 7%;
    line-height: 1.6;
    color: #000;
}

>>>.right-col .comprasion-content b {
    text-transform: uppercase;
}

>>>.right-col .comprasion-content li::before {
    content: "";
    position: absolute;
    width: 12px;
    height: 35px;
    left: -21px;
    top: 8px;
    background-image: url('../../src/assets/icons/close.png');
    background-size: contain;
    background-repeat: no-repeat;
}

@media (max-width: 1024px) {
    .home-highlight h1 {
        font-size: 26px;
        line-height: 36px;
    }

    .hero-banner h1 {
        font-size: clamp(30px, 3em, 50px);
        padding-left: 0;
        padding-right: 0;
    }

    >>>.comprasion .content {
        padding-bottom: 0.5%;
    }
}

@media (max-width: 1024px) {
    .comprasion .content {
        padding-bottom: 0.5%;
    }
}


@media (max-width: 768px) {
    .comprasion .content {
        padding-bottom: 40px;
    }

    >>>.comprasion .left-col,
    >>>.comprasion .right-col {
        -webkit-box-flex: 0;
        -ms-flex: 0 1 100%;
        flex: 0 1 100%;
    }

    >>>.comprasion .left-col .comprasion-content {
        padding: 12% 6.6% 8% 6.6%;
    }

    >>>.right-col .comprasion-content h3 {
        font-size: 20px;
        margin: 0 auto;
        color: #000;
    }
}



>>>.simple-steps .content {
    max-width: 1440px;
    width: 93%;
}

.simple-steps h2 {
    font-size: 48px;
    line-height: 1.5;
    text-align: center;
    margin: 0 auto;
    color: #000;
}

body .v-application .text-center {
    z-index: 2;
}

body .v-application .simple-steps button.v-btn {
    background-color: #2D76E3;
    color: #FFFFFF;
    margin: 0 auto !important;
    margin-top: 90px !important;
    /* padding: 0 33px !important; */
    max-width: 161px !important;
    width: 100%;
    -webkit-transition: all .35s;
    -o-transition: all .35s;
    transition: all .35s;
}

body .v-application .simple-steps button.v-btn span {
    color: #FFFFFF;
}

body .v-application .simple-steps button.v-btn:hover {
    opacity: 0.85;
}

>>>.simple-steps .v-btn__content {
    color: #fff;
}

@media (max-width: 980px) {

    .simple-steps h2 {
        font-size: 26px;
    }

}

@media (max-width: 979px) {
    .comprasion .content {
        padding-bottom: 9%;
    }
}

@media (max-width: 768px) {
    .simple-steps h2 {
        font-size: 24px;
    }

    .comprasion .content {
        padding-bottom: 30px;
    }

    body .v-application .simple-steps button.v-btn {
        margin-top: 0px !important;
    }
}

.home-testimonials-title h2 {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 48px;
    line-height: 72px;
    /* identical to box height, or 150% */

    text-align: center;

    /* Black */

    color: #000000;
}

>>>.home-testimonials .v-window__next img,
>>>.home-testimonials .v-window__prev img {
    padding: 5px;
}

>>>.home-testimonials .v-window__next,
>>>.home-testimonials .v-window__prev {
    background: transparent;
    top: calc(50% - 15px);
}

>>>.home-testimonials .v-window__next:hover,
>>>.home-testimonials .v-window__prev:hover {
    cursor: pointer;
}

.hero-banner .container {
    max-width: 93%;
    margin-left: auto;
    margin-right: auto;
}

.block-news__card-wrap {
    width: 48.5%;
    cursor: pointer;
}

.block-news .row {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    width: 100%;
    margin: auto;
}

@media (max-width: 1400px) {
    .hero-banner h1 {
        font-size: clamp(30px, 3em, 64px);
        line-height: 1.125;
    }

    .home-testimonials-title h2 {
        font-size: 26px;
        line-height: 1.125;
        max-width: 90%;
        margin-left: auto;
        margin-right: auto;
    }

    .best-apartments.bg-v-2,
    .best-apartments.bg-v-3 {
        background-size: cover !important;
    }

    .best-apartments.bg-v-2:before,
    .best-apartments.bg-v-3:before {
        right: 0;
        width: 100%;
        background: -webkit-gradient(linear, right top, left top, color-stop(40%, #373E55), to(rgba(55, 62, 85, 0)));
        background: -o-linear-gradient(right, #373E55 40%, rgba(55, 62, 85, 0) 100%);
        background: linear-gradient(270deg, #373E55 40%, rgba(55, 62, 85, 0) 100%);
    }

    .block-news .content,
    .home-testimonials {
        width: 93%;
    }

    .simple-steps h2 {
        font-size: 36px;
    }

    >>>.simple-steps .steps-content {
        margin-top: 50px;
    }

    .about .content .content-img-col {
        margin: auto;
    }
}

@media (max-width: 1024px) {

    .comprasion .content,
    >>>.about .content,
    .simple-steps .content,
    .home-testimonials,
    .hero-banner .container,
    .content.major-cities-content,
    .block-news div.content,
    .best-apartments div.content {
        width: 100%;
        padding-left: 20px;
        padding-right: 20px;
    }

    .best-apartments {
        padding: 50px 0;
    }

    .block-news {
        margin-bottom: 80px;
        margin-top: 80px;
    }

    .best-apartments.bg-v-1:before,
    .best-apartments.bg-v-2:before,
    .best-apartments.bg-v-3:before {
        left: 0;
        right: 0;
        width: 100%;
        background: -webkit-gradient(linear, right top, left top, color-stop(15%, #373E55), to(rgba(55, 62, 85, 0.5)));
        background: -o-linear-gradient(right, #373E55 15%, rgba(55, 62, 85, 0.5) 100%);
        background: linear-gradient(270deg, #373E55 15%, rgba(55, 62, 85, 0.5) 100%);
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }

    .best-apartments .row .col-12:first-child {
        margin-right: auto;
    }

    .home-testimonials .v-window-item .col-12 p {
        padding: 50px;
    }

    .col-12 .block-news__card {
        max-width: 97%;
    }

    body .v-application .simple-steps button.v-btn {
        margin-top: 50px !important;
    }

    .simple-steps h2 {
        font-size: 30px;
    }

    .best-apartments.bg-v-1 {
        background-size: cover !important;
    }
}

@media (max-width: 980px) {
    body .v-application .simple-steps button.v-btn {
        margin-top: 0 !important;
    }

    .best-apartments.bg-v-1 {
        background: -webkit-gradient(linear, left bottom, left top, from(rgba(0, 0, 0, 0.5)), to(rgba(0, 0, 0, 0.1))), url(/img/background-new.jpg);
        background: -o-linear-gradient(bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.1)), url(/img/background-new.jpg);
        background: linear-gradient(0deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)), url(../../src/assets/media/background-new.jpg);
    }
}

@media (max-width: 768px) {
    .hero-banner h1 {
        font-size: clamp(30px, 2em, 64px);
    }

    >>>.about {
        padding: 50px 0;
    }

    >>>.best-apartments .dashboard ul li {
        line-height: 1.9;
    }

    >>>.best-apartments .dashboard ul li:last-child {
        margin-bottom: 0;
    }

    >>>.best-apartments .dashboard {
        padding: 35px 15px;
    }

    >>>.home-testimonials .v-window__next {
        right: -15px;
    }

    >>>.home-testimonials .v-window__prev {
        left: -15px;
    }

    div.hero-banner {
        padding-top: 100px;
        padding-bottom: 70px;
        min-height: 200px;
        height: auto;
    }

    .hero-banner .container {
        max-width: 100%;
    }

    .block-news__card-wrap {
        width: 100%;
    }

    .block-news__card-wrap:last-child {
        margin-top: 2rem;
    }

    .block-news div.content .row {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
    }

    .block-news__card {
        max-width: 100%;
    }

    .home-testimonials__container {
        padding-bottom: 80px;
        height: 565px;
    }

    >>>.home-testimonials__container .v-window__container {
        max-height: 470px;
    }

    .simple-steps .step:last-child {
        margin-bottom: 50px;
    }

    .major-cities .second-card,
    .major-cities .third-card {
        width: 50%;
        height: 200px
    }

    .major-cities .second-card {
        right: 0;
        top: 240px;
    }

    .major-cities .second-card .v-card,
    .major-cities .third-card .v-card,
    .major-cities .forth-card .v-card,
    .major-cities .second-card,
    .major-cities .third-card {
        height: 210px;
    }

    .major-cities .second-card .v-card .v-image,
    .major-cities .third-card .v-card .v-image,
    .major-cities .forth-card .v-card .v-image {
        height: 150px;
    }

    .major-cities .five-card {
        height: 197px;
        bottom: 5px;
    }

    .major-cities .forth-card {
        bottom: -30px;
    }

    >>>.major-cities .five-card .v-card .v-image,
    >>>.major-cities .five-card .v-card .v-responsive__content {
        height: 140px;
    }

    .major-cities .forth-card {
        height: 285px;
    }

    .major-cities .forth-card .v-card {
        height: 250px;
    }

    .major-cities .forth-card .v-card .v-image {
        height: 195px;
    }

    >>>.right-col .comprasion-content {
        padding-bottom: 1%;
    }

    .simple-steps h2 {
        font-size: 26px;
    }

    >>>.simple-steps .steps-content {
        margin-top: 30px;
    }
}

@media (max-width: 575px) {
    .hero-banner h1 {
        font-size: 30px;
    }

    .home-testimonials-title h2 {
        font-size: 24px;
    }
}

@media (max-width: 530px) {
    .home-testimonials__container {
        height: auto;
        padding-bottom: 0;
    }

    .home-testimonials .v-window-item:after {
        right: 37.3px;
        bottom: 74px;
    }

    .home-testimonials .v-window-item:before {
        right: 19px;
        bottom: 48.5px;
    }

    >>>.home-testimonials__container .v-window__container {
        max-height: 590px;
    }
}

@media (max-width: 450px) {

    .major-cities .second-card,
    .major-cities .third-card {
        width: 50%;
        height: 200px
    }

    .major-cities .second-card {
        right: 0;
        top: 240px;
    }

    .major-cities .second-card .v-card,
    .major-cities .third-card .v-card,
    .major-cities .forth-card .v-card,
    .major-cities .second-card,
    .major-cities .third-card {
        height: 160px;
    }

    .major-cities .second-card .v-card .v-image,
    .major-cities .third-card .v-card .v-image,
    .major-cities .forth-card .v-card .v-image {
        height: 110px;
    }

    .major-cities .five-card {
        height: 147px;
    }

    >>>.major-cities .five-card .v-card .v-image,
    >>>.major-cities .five-card .v-card .v-responsive__content {
        height: 100px;
    }

    .major-cities .forth-card {
        height: 235px;
    }

    .major-cities .forth-card .v-card {
        height: 200px;
    }

    .major-cities .forth-card .v-card .v-image {
        height: 155px;
    }

    .major-cities-container {
        height: 500px;
    }

    .major-cities .second-card {
        top: 180px;
    }

    .major-cities .first-card .v-card .v-image {
        height: 220px;
    }

    .major-cities .first-card .v-card {
        height: 274px;
    }

    .major-cities .major-cities-title-mobile {
        font-size: 12px;
    }

    .major-cities-card-content {
        height: 50px;
    }

}
</style>
